import { EmailTypes } from "../types/EmailTypes";
import { Form } from "../classes/Form";
import { GAEventTypes } from "../types/GAEventTypes";
import { GACategoryTypes } from "../types/GACategoryTypes";
import { GA } from "../classes/GA";

export class ContactPage {

  _contactPagWrapperEl;
  _contactFormEl;

  init() {
    this._contactPagWrapperEl = document.querySelector('.contact-page-wrapper');

    if (this._contactPagWrapperEl) {
      this.contactFormActions();
    }
  }

  contactFormActions() {
    if (window['areCookiesPreferencesSet'] && window['cookiesPreferences'].analyticsCookie) {
      GA.gaLoaded(ga => ga('send', 'event', GACategoryTypes.TrackingContactUs, GAEventTypes.ContactStart));
      dataLayer.push({ 'event': `cc_${GACategoryTypes.TrackingContactUs}_${GAEventTypes.ContactStart}` });
    }

    this._contactFormEl = this._contactPagWrapperEl.querySelector('#contact-form');
    const form = new ContactForm(
      this._contactFormEl,
      EmailTypes.ContactForm,
      GACategoryTypes.TrackingContactUs,
      GAEventTypes.ContactSend
    );

    form.init();
  }
}

class ContactForm extends Form {
  afterFormSendTracking() {
    if (window.lintrk) {
      window.lintrk('track', { conversion_id: 8350649 });
    }
  }
}
